export default function initLoadImageGallery() {
    /* Image change + preview image */
    document.querySelectorAll('.product-hero').forEach($productHero => {
      document.querySelectorAll('.image-list .image').forEach($imageLink => {
        $imageLink.addEventListener('click', event => {
          event.preventDefault();

          let imagesContainer = $imageLink.parentElement.parentElement.parentElement;

          if(imagesContainer !== undefined) {
            let previewImage = imagesContainer.getElementsByClassName("preview-image")[0];

            if (previewImage !== undefined) {
              previewImage.setAttribute("src", $imageLink.getAttribute("src"));
              let previewImageContainer = document.querySelector(".preview-image-container");
              if(previewImageContainer !== undefined && previewImageContainer.classList.contains("video-visible")) {
                previewImageContainer.classList.remove("video-visible");
              }
            }
          }
        });
      });
    });

    document.querySelectorAll('.preview-image-link').forEach($previewImageLink => {
      $previewImageLink.addEventListener('click', event => {
        event.preventDefault();

        let $productHero = document.querySelector(".product-hero");

        let previewImage = $productHero.getElementsByClassName("images")[0].getElementsByClassName("preview-image")[0];
        let previewImageModal = $productHero.getElementsByClassName("images-modal")[0].getElementsByClassName("preview-image")[0];

        if(previewImage !== undefined && previewImageModal !== undefined) {
          previewImageModal.setAttribute("src", previewImage.getAttribute("src"));
        }

        let imagesContainerModal = document.querySelector(".images-modal");

        if(imagesContainerModal !== undefined) {
          if(!imagesContainerModal.classList.contains("fullscreen")) {
            imagesContainerModal.classList.add("fullscreen");
          }
          if(!document.body.classList.contains("fullscreen")) {
            document.body.classList.add("fullscreen")
          }
        }
      });
    });

    function isYoutubeVideo(videoLink) {
      return videoLink.includes("youtube") || videoLink.includes("ytube") || videoLink.includes("youtu.be");
    }

    document.querySelectorAll('.video-link').forEach($videoLink => {
      $videoLink.addEventListener('click', event => {
        event.preventDefault();

        let videoLinkFrame = event.currentTarget.getElementsByClassName("article-video-container")[0];
        let previewImageContainer = document.querySelector(".preview-image-container");
        if(previewImageContainer !== undefined) {
          let videoPreviewImageContainer = previewImageContainer.getElementsByClassName("video-preview-image")[0];
          if(videoPreviewImageContainer !== undefined) {
            let videoPreviewImage = videoPreviewImageContainer.getElementsByClassName("preview-image")[0];
            if (videoPreviewImage !== undefined) {
              if (videoLinkFrame !== undefined) {
                let videoImage = videoLinkFrame.getElementsByClassName("preview-image")[0];
                if(videoImage !== undefined) {
                  videoPreviewImage.setAttribute("src", videoImage.getAttribute("src"));
                  let videoLink = videoPreviewImageContainer.getElementsByClassName("video-preview-image-link")[0];
                  if(videoLink !== undefined) {
                    videoLink.classList.forEach((classItem) => {
                      if(classItem.includes("index-")) {
                        videoLink.classList.remove(classItem);
                      }
                    });

                    videoImage.classList.forEach((classItem) => {
                      if(classItem.includes("index-")) {
                        videoLink.classList.add(classItem);
                      }
                    });
                  }
                  if(!previewImageContainer.classList.contains("video-visible")) {
                    previewImageContainer.classList.add("video-visible");
                  }
                }
              }
            }
          }
        }
      });
    });

    document.querySelectorAll('.video-preview-image-link').forEach($videoLink => {
      $videoLink.addEventListener('click', event => {
        event.preventDefault();

        let indexClass = "";
        event.currentTarget.classList.forEach((classItem) => {
          if(classItem.includes("index-")) {
            indexClass = classItem;
          }
        });

        const modals = document.querySelectorAll(".video-modal");

        Array.prototype.forEach.call(modals, function (modal) {
          if(modal.classList.contains(indexClass)) {
            if(!modal.classList.contains("fullscreen")) {
              let iframe = modal.getElementsByTagName("iframe")[0];
              if(iframe !== undefined && iframe.getAttribute("src") === "") {
                iframe.setAttribute("src", iframe.getAttribute("data-videolink"));
              }
              modal.classList.add("fullscreen");
            }
            if(!document.body.classList.contains("fullscreen")) {
              document.body.classList.add("fullscreen")
            }
          }
        });
      });
    });

    document.querySelectorAll('.close-fullscreen').forEach($closeFullscreenLink => {
      $closeFullscreenLink.addEventListener('click', event => {
        event.preventDefault();

        let imagesContainerModal = document.querySelector(".images-modal");

        if(imagesContainerModal !== undefined) {
          if(imagesContainerModal.classList.contains("fullscreen")) {
            imagesContainerModal.classList.remove("fullscreen");
          }
          if(document.body.classList.contains("fullscreen")) {
            document.body.classList.remove("fullscreen")
          }
        }
      });
    });

    document.querySelectorAll('.close-video-fullscreen').forEach($closeVideoFullscreenLink => {
      $closeVideoFullscreenLink.addEventListener('click', event => {
        event.preventDefault();

        const modals = document.querySelectorAll(".video-modal");

        Array.prototype.forEach.call(modals, function (modal) {
          if(modal.classList.contains("fullscreen")) {
            let frame = modal.getElementsByTagName("iframe")[0];
            if(frame !== undefined) {
              frame.setAttribute("src", "");
            }
            modal.classList.remove("fullscreen");
          }
        });

        if(document.body.classList.contains("fullscreen")) {
          document.body.classList.remove("fullscreen")
        }
      });
    });

    document.addEventListener('keydown', evt => {
      if (evt.key === 'Escape') {
        document.querySelectorAll('.close-video-fullscreen').forEach($closeVideoFullscreenLink => {
          $closeVideoFullscreenLink.click();
        });
        document.querySelectorAll('.close-fullscreen').forEach($closeFullscreenLink => {
          $closeFullscreenLink.click();
        });
      }
    });

    document.addEventListener("click", evt => {
      if(document.body.classList.contains("fullscreen") && evt.target.classList.contains("fullscreen")) {
        document.querySelectorAll('.close-video-fullscreen').forEach($closeVideoFullscreenLink => {
          $closeVideoFullscreenLink.click();
        });
        document.querySelectorAll('.close-fullscreen').forEach($closeFullscreenLink => {
          $closeFullscreenLink.click();
        });
      }
    });
}

